import { render } from "./WorkspaceIcon.vue?vue&type=template&id=59008746"
import script from "./WorkspaceIcon.vue?vue&type=script&lang=js"
export * from "./WorkspaceIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__